<template>
  <joy-page :joyPageStatus="joyPageStatus">
    <div class="setHeightFullGrey">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <template v-if="listChildren.length==0">
          <noneData></noneData>
        </template>
        <template v-else>
          <div class="marginTopXm">
            <van-cell
              class="marginBottomXm"
              :title="item.name"
              v-for="(item,index) in listChildren"
              :key="index"
            >
              <van-icon
                @click="childDetail(item.id)"
                slot="icon"
                size="30"
                :name="item.sex=='男'?sexM:sexF"
                style="line-height: inherit;margin-right: 10px;"
              />
              <!-- <template slot="default"> -->
              <van-button
                v-if=""
                size="mini"
                type="default"
                @click="submitExceptionMessage(item.id)"
              >异常</van-button>
              <van-button
                v-if="item.is_up==0"
                @click="goUpload(item.id)"
                size="mini"
                type="default"
              >上传</van-button>
              <van-button
                v-else
                @click="goUpload(item.id)"
                size="mini"
                type="primary"
              >上传</van-button>
              <van-button
                v-if="item.is_comment==0"
                @click="goComment(item.id)"
                size="mini"
                type="default"
              >评论</van-button>
              <van-button
                v-else
                @click="goComment(item.id)"
                size="mini"
                type="primary"
              >评论</van-button>
              <!-- </template> -->
            </van-cell>
          </div>
        </template>
      </van-pull-refresh>
    </div>

    <van-dialog
      v-model="showPersonInfor"
      :title="PersonInforDetail.name"
      show-cancel-button
      :showCancelButton="false"
    >
      <van-cell
        title="性别"
        :value="PersonInforDetail.sex"
      />
      <van-cell
        title="年龄"
        :value="PersonInforDetail.age"
      />
      <van-cell
        title="生日"
        :value="PersonInforDetail.birthday"
      />
      <van-cell
        title="证件"
        :value="PersonInforDetail.idnumber"
      />
      <van-cell
        title="手机"
        :value="PersonInforDetail.phone"
      />
    </van-dialog>

    <!-- 异常弹框 -->
    <van-popup
      v-model="showAnomaly"
      position="bottom"
      round
      :style="{ height: '60%' }"
    >
      <van-field
        clearable
        label="标题"
        placeholder="请输入标题"
      />
      <van-field
        readonly
        clickable
        label="异常级别"
        :value="abnormalValue"
        placeholder="请选择异常级别"
        @click="showAbnormalLevel = true"
      />
      <van-field
        type="textarea"
        clearable
        label="异常信息"
        placeholder="请输入异常信息"
        rows="3"
        autosize
      />
      <van-cell title="图片上传"></van-cell>
      <div class="paddingXm">
        <van-uploader
          v-model="imgListMode2"
          multiple
        />
      </div>
      <van-button
        type="primary"
        size="large"
        @click="submitException()"
      >保存</van-button>
    </van-popup>
    <!-- /异常弹框 -->

    <!-- 异常级别弹框 -->
    <van-popup
      v-model="showAbnormalLevel"
      round
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showAbnormalLevel = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- /异常级别弹框 -->

  </joy-page>
</template>

<script>
export default {
  props: ['camp_id', 'user_id', 'type'],
  data() {
    return {
      showPersonInfor: false,
      joyPageStatus: '',
      isLoading: false,
      sexM: this.$mAssetsPath.sexM,
      sexF: this.$mAssetsPath.sexF,
      // 孩子的数据
      listChildren: [],
      PersonInforDetail: '',
      // 异常窗口
      showAnomaly: false,
      // 异常图片本地
      imgListMode2: [],
      // 异常图片上传
      addpic: [],
      // 异常级别
      columns: ['一级', '二级', '三级'],
      //异常级别弹层
      showAbnormalLevel: false,
      // 选中的异常级别的值
      abnormalValue: '',
    }
  },
  methods: {
    // 打开提交异常信息
    submitExceptionMessage(id) {
      this.showAnomaly = true
    },
    // 选择异常级别
    onConfirm(value) {
      this.abnormalValue = value
      this.showAbnormalLevel = false
    },
    // 提交异常
    submitException() {},
    childDetail(id) {
      try {
        this.$axios.get('children/info?children_id=' + id).then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.PersonInforDetail = res.data.data
            this.showPersonInfor = true
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    loadComment() {
      this.joyPageStatus = 'loading'
      try {
        this.$axios
          .get(
            'children/list?camp_id=' +
              this.camp_id +
              '&parent_id=' +
              this.user_id
          )
          .then((res) => {
            this.joyPageStatus = 'success'
            if (res.data.code == 200) {
              this.listChildren = res.data.data
            }
          })
          .catch(function (error) {
            this.joyPageStatus = 'fail'
          })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    goComment(id) {
      console.log('去点击', id, this.camp_id)
      this.$router.push({
        path: '/subPackages/myTask/comment',
        query: {
          children_id: id,
          camp_id: this.camp_id,
        },
      })
    },
    goUpload(id) {
      this.$router.push({
        path: '/subPackages/myTask/upload',
        query: {
          children_id: id,
          camp_id: this.camp_id,
        },
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.reload()
        this.$toast('刷新成功')
      }, 1000)
    },
    reload() {
      this.listChildren = []
      this.loadComment()
    },
  },
  created() {
    this.loadComment()
  },
  watch: {
    imgListMode2(val) {
      const that = this
      for (let i in val) {
        that
          .$lrz(val[i].content, {
            width: that.$mConfig.width,
            quality: that.$mConfig.quality,
          })
          .then(function (rst) {
            console.log('rst.base64是', rst.base64)
            that.addpic.push(rst.base64)
          })
          .catch(function (err) {
            console.log(err)
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .van-cell__title {
  flex: inherit;
}
</style>
